import React, { useState } from 'react';

import styled from 'styled-components';

import { EDIT_MODAL_CONTROL_TYPE } from './constants';
import EditDataModal from './EditDataModal';

const Container = styled.div`
  display: flex;
`;

const EditButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  color: var(--deep-blue);
  width: 60px;
  height: 28px;
  background-color: var(--lighter-gray);
  border-radius: 4px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const LinkContent = styled.div`
  display: flex;
  padding: 15px 0px;
  gap: 4px;
`;

const NoDataLabel = styled.div`
  color: var(--text-secondary);
`;

const EditLink = styled.div`
  color: var(--dark-blue);
  cursor: pointer;
`;

interface Props {
  type: 'button' | 'link';
  title: string;
  expanded?: boolean;
  show?: boolean;
  buttonDataTestId?: string;
  linkDataTestId?: string;
  onSuccess: () => void;
  children: React.ReactNode;
}

const EditModalControl = ({ type, title, show, children, onSuccess, expanded, buttonDataTestId, linkDataTestId }: Props) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSuccess = () => {
    handleClose();
    onSuccess();
  };

  const showAddDataLabel = type === EDIT_MODAL_CONTROL_TYPE.LINK && show;
  const hideAll = type === EDIT_MODAL_CONTROL_TYPE.BUTTON && !show;

  if (hideAll) {
    return null;
  }

  return (
    <Container>
      {showModal && (
        <EditDataModal
          open={showModal}
          title={title}
          expanded={expanded}
          onClose={handleClose}
          onSuccess={handleSuccess}
        >
          {children}
        </EditDataModal>
      )}

      {type === EDIT_MODAL_CONTROL_TYPE.BUTTON && (
        <EditButton data-test-id={buttonDataTestId} onClick={() => setShowModal(true)}>
          Edit
        </EditButton>
      )}
      {type === EDIT_MODAL_CONTROL_TYPE.LINK && (
        <LinkContent>
          <NoDataLabel>There is nothing here.</NoDataLabel>
          {showAddDataLabel && (
            <EditLink data-test-id={linkDataTestId} onClick={() => setShowModal(true)}>
              Add some data
            </EditLink>
          )}
        </LinkContent>
      )}
    </Container>
  );
};

export default EditModalControl;
